<template>
  <div>
    <div v-if="contexts.length && isHost" class="pa-3">
      <action-screen-share-controls
        v-for="c in contexts"
        :key="c.id"
        :context="c"
        :getSingleParticipant="getSingleParticipant"
        @update="updateAction(c, $event)"
        @close="closeAction(c)"
      />
    </div>

    <portal to="receivedAction">
      <action-screen-share-content
        v-if="showActionContent(receivedState)"
        :class="actionContentClass"
        :state="receivedState"
        :getSingleParticipant="getSingleParticipant"
      />
    </portal>
  </div>
</template>

<script>
import ActionScreenShareControls from './ActionScreenShareControls';
import ActionScreenShareContent from './ActionScreenShareContent';
import GenericAction from '../GenericAction';

export default {
  name: 'ActionScreenShare',
  mixins: [GenericAction],
  components: {
    ActionScreenShareControls,
    ActionScreenShareContent,
  },
  data() {
    return {
      receivedState: {},
    };
  },
  methods: {
    selected() {
      this.addContext({
        show: false,
        hostId: '',
      });
    },

    updateAction(context) {
      context.state.hostId = this.roomInfo.identity;
      this.api.trigger('stateChange', { contexts: this.contexts });
      this.updateParticipants(context);
    },

    received(data) {
      this.receivedState = data;
    },
  },
};
</script>
